/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import moment from 'moment'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import * as Yup from 'yup'

import { Collapse } from '@material-ui/core'
import { BiCake } from 'react-icons/bi'
import { FiClock, FiDollarSign } from 'react-icons/fi'
import usePersistedState from '../../hooks/usePersistedState'
import { formatValue } from '../../utils/formatValues'
import getValidationErrors from '../../utils/getValidationErrors'
import { ValorMascarar } from '../../utils/masks'

import Button from '../../components/Button'
import Header from '../../components/Header'
import Input from '../../components/Input'

import Container from '../../components/Container'
import InputSlider from '../../components/InputSlider'
import Line from '../../components/Line'
import calculaIdade from '../../utils/calculaIdade'
import { UserData, UserDetails } from '../../utils/interfaces'
import { BtnVoltar } from '../06-Simulation/styles'
import { Content, InfoContent, TextBox, UPBoxSlider } from './styles'

const Contribution: React.FC = () => {
  const [userDetails, setUserDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [userData, setUserData] = usePersistedState<UserData>(
    'userData',
    {} as UserData,
  )
  const [idadeApos, setIdadeApos] = useState(userDetails.age)
  const [salarioValue, setSalarioValue] = useState(
    userDetails.salario > 0 ? userDetails.salario : 0,
  )
  const [vlrCtbBasica, setVlrCtbBasica] = useState(
    userDetails.contribuicaoBasica > 0 ? userDetails.contribuicaoBasica : 0,
  )
  const [vlrCtbPatrocinadora] = useState(
    userDetails.contribuicaoPatrocinadora > 0
      ? userDetails.contribuicaoPatrocinadora
      : 0,
  )
  const [pctCtbBas, setPctCtbBas] = useState(
    userDetails.pctContribuicaoBasica > 0
      ? userDetails.pctContribuicaoBasica
      : 0,
  )
  const [pctCtbSup, setPctCtbSup] = useState(
    userDetails.pctContribuicaoSuplementar > 0
      ? userDetails.pctContribuicaoSuplementar
      : 0,
  )
  const [vlrFixoCtbSup, setVlrFixoCtbSup] = useState(
    userDetails.contribuicaoSuplementar > 0
      ? userDetails.contribuicaoSuplementar
      : 0,
  )
  const [vlrCtbSup, setVlrCtbSup] = useState(salarioValue * (pctCtbSup / 100))

  const [tipCtbBasica, setTipCtbBasica] = usePersistedState('tipCtbBasica', '') // P = Percentual sobre o salário || M = Máxima permitida pelo plano
  const [tipCtbAdic, setTipCtbAdic] = usePersistedState('tipCtbAdic', '') // P = Percentual sobre o salário || F = Valor fixo

  const [auxVlrCtbAdic, setAuxVlrCtbAdic] = useState(
    tipCtbAdic === 'P' ? vlrCtbSup : vlrFixoCtbSup,
  )
  const [warning, setWarning] = useState(false)

  const [USB] = usePersistedState<number>('usb', 322.93) // 292.54
  const history = useHistory()
  const formRef = useRef<FormHandles>(null)

  const [minPctCtbBasica, setMinPctCtbBasica] = useState(0)
  const [maxPctCtbBasica, setMaxPctCtbBasica] = useState(0)
  const [maxVlrCtbBasica, setMaxVlrCtbBasica] = useState(0)

  useEffect(() => {
    if (salarioValue !== 0 && salarioValue !== undefined) {
      if (salarioValue <= USB * 23) {
        setMinPctCtbBasica(0)
        setMaxPctCtbBasica(2)
        setMaxVlrCtbBasica(salarioValue * 0.02)
      } else if (salarioValue > USB * 23 && salarioValue <= USB * 46) {
        setMinPctCtbBasica(0)
        setMaxPctCtbBasica(4)
        setMaxVlrCtbBasica(salarioValue * 0.04)
      } else if (salarioValue > USB * 46 && salarioValue <= USB * 69) {
        setMinPctCtbBasica(0)
        setMaxPctCtbBasica(6)
        setMaxVlrCtbBasica(salarioValue * 0.06)
      } else if (salarioValue > USB * 69 && salarioValue <= USB * 92) {
        setMinPctCtbBasica(0)
        setMaxPctCtbBasica(7)
        setMaxVlrCtbBasica(salarioValue * 0.07)
      } else if (salarioValue > USB * 92) {
        setMinPctCtbBasica(0)
        setMaxPctCtbBasica(8)
        setMaxVlrCtbBasica(salarioValue * 0.08)
      }
    }
  }, [USB, salarioValue])

  useEffect(() => {
    if (tipCtbBasica === 'M') {
      setVlrCtbBasica(maxVlrCtbBasica * 1)
    } else if (tipCtbBasica === 'P') {
      const value = (salarioValue * pctCtbBas) / 100
      setVlrCtbBasica(isNaN(value) ? 0 : value)
    } else {
      setVlrCtbBasica(0)
    }
  }, [maxVlrCtbBasica, pctCtbBas, salarioValue, tipCtbBasica])

  const mudarVlrFixoCtbAdic = useCallback(
    valor => {
      const v = valor.replace(',', '').replaceAll('.', '')
      if (isNaN(v)) {
        setVlrFixoCtbSup(vlrFixoCtbSup)
      } else {
        const m = Math.floor(v.length - 2)
        const a = `${v.substr(0, m)}.${v.substr(m)}`
        const f = parseFloat(a)
        setVlrFixoCtbSup(f)
        setAuxVlrCtbAdic(f)
      }
    },
    [vlrFixoCtbSup, setVlrFixoCtbSup],
  )

  const handleCalculaContribBasica = useCallback(
    valor => {
      const valueCSup = (salarioValue * valor) / 100
      setPctCtbBas(valor)
      setVlrCtbBasica(valueCSup)
    },
    [salarioValue],
  )

  const handleChangePctBasica = useCallback(
    e => {
      const t = e
      if (tipCtbBasica === 'P') {
        if (isNaN(t)) {
          handleCalculaContribBasica(0)
        } else {
          handleCalculaContribBasica(t)
        }
      }
    },
    [handleCalculaContribBasica, tipCtbBasica],
  )

  const handleCalculaContribSup = useCallback(
    valor => {
      if (tipCtbAdic === 'P') {
        const valueCSup = (salarioValue * valor) / 100
        setPctCtbSup(valor)
        setVlrCtbSup(valueCSup)
        setAuxVlrCtbAdic(valueCSup)
      }
    },
    [salarioValue, tipCtbAdic],
  )

  const handleChangePctSup = useCallback(
    e => {
      const t = e
      if (isNaN(t)) {
        handleCalculaContribSup(0)
      } else {
        handleCalculaContribSup(t)
      }
    },
    [handleCalculaContribSup],
  )

  const mudarSalario = useCallback(
    valor => {
      const v = valor.replace(',', '').replaceAll('.', '')
      if (isNaN(v)) {
        setSalarioValue(salarioValue)
      } else {
        const m = Math.floor(v.length - 2)
        const a = `${v.substr(0, m)}.${v.substr(m)}`
        const f = parseFloat(a)
        setSalarioValue(f)
      }
    },
    [salarioValue],
  )

  const handleSubmit = useCallback(
    async data => {
      if (tipCtbBasica === '') {
        setWarning(true)
        const box = document.getElementById('ctbBasica') as HTMLDivElement
        const altura = box.clientHeight
        window.scrollTo({
          top: altura,
          left: 0,
          behavior: 'smooth',
        })
      } else {
        try {
          const now = new Date()
          const bday = data.birthdate.split('/').reverse().join('-')
          const ano = bday.split('-')[0]
          const anosContrib2 =
            idadeApos - (now.getFullYear() - parseInt(ano, 10))
          const idadeMinima =
            calculaIdade(data.birthdate.split('/').reverse().join('-')) < 55
              ? 55
              : calculaIdade(data.birthdate.split('/').reverse().join('-')) + 1

          formRef.current?.setErrors({})

          const schema = Yup.object().shape({
            birthdate: Yup.string()
              .required('Campo obrigatório')
              .test(
                '',
                'A data de nascimento não pode ser maior que hoje.',
                () =>
                  moment() >
                    moment(data.birthdate.split('/').reverse().join('-')) ||
                  data.birthdate === '',
              )
              .test(
                '',
                'Data de nascimento inválida',
                () =>
                  moment(
                    data.birthdate.split('/').reverse().join('-'),
                  ).isValid() || data.birthdate === '',
              )
              .test(
                '',
                'Data de nascimento inválida',
                () =>
                  calculaIdade(data.birthdate.split('/').reverse().join('-')) <=
                    115 || data.birthdate === '',
              ),
            // cpf: Yup.string()
            //   .required('Digite o CPF do titular')
            //   .test(
            //     '',
            //     'CPF inválido',
            //     () =>
            //       validaCPF(data.cpf.replaceAll('.', '').replace('-', '')) ||
            //       data.cpf === '',
            //   ),
            age: Yup.number()
              .typeError(
                'Digite a idade desejada para a aposentadoria para realizar a simulação',
              )
              .required(
                'Digite a idade desejada para a aposentadoria para realizar a simulação',
              )
              .min(
                idadeMinima,
                `Idade inválida. Por favor, escolha uma idade igual ou superior a ${idadeMinima} anos`,
              )
              .max(115, 'Idade inválida.'),
            salario: Yup.string()
              .test('', 'Salário inválido.', () => salarioValue <= 200000)
              .required('Campo obrigatório'),
            pctContribuicaoSup: Yup.number().test(
              '',
              'Percentual inválido. Escolha no máximo 100%',
              () => pctCtbSup <= 100,
            ),
          })

          await schema.validate(data, { abortEarly: false })

          setUserData({
            ...userData,
            // cpf: data.cpf,
            birthdate: bday,
          })

          setUserDetails({
            ...userDetails,
            salario: salarioValue,
            contribuicaoBasica: vlrCtbBasica,
            contribuicaoPatrocinadora: vlrCtbPatrocinadora,
            pctContribuicaoBasica: tipCtbBasica === 'P' ? pctCtbBas : 0,
            contribuicaoSuplementar: auxVlrCtbAdic,
            pctContribuicaoSuplementar: tipCtbAdic === 'P' ? pctCtbSup * 1 : 0,
            years: anosContrib2,
            age: idadeApos,
          })

          history.push('/simulation')
        } catch (err) {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
          formRef.current?.setErrors(
            getValidationErrors(err as Yup.ValidationError),
          )
        }
      }
    },
    [
      tipCtbAdic,
      auxVlrCtbAdic,
      history,
      idadeApos,
      pctCtbBas,
      pctCtbSup,
      salarioValue,
      setUserData,
      setUserDetails,
      tipCtbBasica,
      userData,
      userDetails,
      vlrCtbBasica,
      vlrCtbPatrocinadora,
    ],
  )

  const marksBasica = []
  for (let i = minPctCtbBasica; i <= maxPctCtbBasica; i += 0.5) {
    marksBasica.push({
      value: i,
      label: Math.floor(i) === i ? `${i.toString().replace('.', ',')}%` : '',
    })
  }

  const marksSup = []
  for (let i = 0; i <= 15; i += 0.5) {
    marksSup.push({
      value: i,
      label: Math.floor(i) === i ? `${i.toString().replace('.', ',')}%` : '',
    })
  }

  const handleTipoCtbBasica = useCallback(
    (tipo: string) => {
      if (tipo === 'M') {
        setVlrCtbBasica(maxVlrCtbBasica * 1)
      } else if (tipo === 'P') {
        setVlrCtbBasica(salarioValue * (pctCtbBas / 100))
      }
      setTipCtbBasica(tipo)
      setWarning(false)
    },
    [maxVlrCtbBasica, pctCtbBas, salarioValue, setTipCtbBasica],
  )

  const handleTipoCtbAdic = useCallback(
    (tipo: string) => {
      if (tipo === 'P') {
        setVlrCtbSup(salarioValue * (pctCtbSup / 100))
        setAuxVlrCtbAdic(salarioValue * (pctCtbSup / 100))
      } else if (tipo === 'F') {
        setVlrFixoCtbSup(vlrFixoCtbSup)
        setAuxVlrCtbAdic(vlrFixoCtbSup)
      }
      setTipCtbAdic(tipo)
    },
    [pctCtbSup, salarioValue, setTipCtbAdic, vlrFixoCtbSup],
  )

  const handleClick = useCallback(() => {
    formRef.current?.submitForm()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          initialData={{
            age: userDetails.age,
            // cpf: userData.cpf,
            salario:
              userDetails.salario === undefined || userDetails.salario === null
                ? ''
                : ValorMascarar(userDetails.salario.toFixed(2).toString()),
            birthdate:
              userData.birthdate === undefined
                ? ''
                : userData.birthdate.toString().split('-').reverse().join('/'),
            pctContribuicaoSup: pctCtbSup,
            contribuicaoSuplementar:
              userDetails.contribuicaoSuplementar === undefined ||
              userDetails.contribuicaoSuplementar === null
                ? ''
                : ValorMascarar(
                    userDetails.contribuicaoSuplementar.toFixed(2).toString(),
                  ),
          }}
        >
          <Content>
            <strong>Simulação de Contribuição</strong>
            <TextBox>
              <p>
                Será descontada mensalmente de sua folha de pagamento. A empresa
                também fará a contribuição no mesmo valor.
              </p>
              <p>
                Para isso, defina a porcentagem de desconto sobre o seu salário
                e simule sua contribuição mensal.
              </p>
            </TextBox>
            <Line />
            <Input
              icon={BiCake}
              name="birthdate"
              placeholder="Data de nascimento"
              mask="date"
            />
            {/* <Input
              placeholder="CPF"
              name="cpf"
              icon={MdSecurity}
              type="tel"
              mask="cpf"
            /> */}
            <Input
              icon={FiDollarSign}
              name="salario"
              mask="currency"
              type="text"
              placeholder="Qual o seu salário (R$)?"
              onChange={e => mudarSalario(e.target.value)}
            />
            <Input
              icon={FiClock}
              type="number"
              name="age"
              value={idadeApos}
              min={50}
              sufix="anos"
              placeholder="Qual a idade desejada para a aposentadoria?"
              onChange={e => setIdadeApos(parseInt(e.target.value, 10))}
            />
          </Content>
          <Content>
            <strong>Contribuição básica</strong>
            <InfoContent>
              <div className="infoSimple">
                <p>Valor da contribuição básica do participante</p>
              </div>
              <Collapse in={warning} style={{ marginTop: '8px' }}>
                <span className="error">Escolha sua contribuição</span>
              </Collapse>
              <div className="infoSimple">
                <input
                  type="checkbox"
                  id="max"
                  name="max"
                  checked={tipCtbBasica === 'M'}
                  onChange={e => {
                    handleTipoCtbBasica(e.target.checked ? 'M' : '')
                  }}
                />
                <label htmlFor="max">
                  {tipCtbBasica === 'M' ? (
                    <>
                      Básica máxima:{' '}
                      <strong>{formatValue(maxVlrCtbBasica)}</strong>
                    </>
                  ) : (
                    <>Básica máxima</>
                  )}
                </label>
              </div>
              <div className="infoSimple">
                <input
                  type="checkbox"
                  id="pct"
                  name="pct"
                  checked={tipCtbBasica === 'P'}
                  onChange={e => {
                    handleTipoCtbBasica(e.target.checked ? 'P' : '')
                  }}
                />
                <label htmlFor="pct">
                  {tipCtbBasica === 'P' ? (
                    <>
                      Básica percentual fixo:{' '}
                      <strong>{formatValue(vlrCtbBasica)}</strong>
                    </>
                  ) : (
                    <>Básica percentual fixo</>
                  )}
                </label>
              </div>
              <UPBoxSlider style={{ paddingTop: '0px' }}>
                <InputSlider
                  name="rangePctContribBasica"
                  functionChange={e => handleChangePctBasica(e)}
                  start={minPctCtbBasica}
                  end={maxPctCtbBasica}
                  initialValue={pctCtbBas}
                  step={0.1}
                  marks={marksBasica}
                  valueLabelDisplay="off"
                  disabled={tipCtbBasica !== 'P'}
                  inputDisabled={tipCtbBasica !== 'P'}
                  sufix="%"
                />
              </UPBoxSlider>
            </InfoContent>
            <InfoContent>
              <div className="infoSimple">
                <p>
                  Contrapartida da patrocinadora (100%):{' '}
                  <strong>{formatValue(vlrCtbBasica)}</strong>
                </p>
              </div>
            </InfoContent>
            <Line />
            <InfoContent>
              <div className="infoTotal" id="ctbBasica">
                <div>
                  <h4>Valor total de contribuições básica ao plano: </h4>
                  <small>(Participante + Patrocinadora)</small>
                </div>
                <strong>{formatValue(vlrCtbBasica * 2)}</strong>
              </div>
            </InfoContent>
          </Content>
          <Content>
            <strong>Contribuição adicional</strong>
            <TextBox>
              <p>
                A contribuição adicional é opcional e, em relação a ela, não há
                contrapartida da patrocinadora. Os valores aportados no plano
                são rentabilizados mensalmente.
              </p>
              <p>
                Você sabia que, além da contribuição básica, a contribuição
                adicional feita para planos de previdência complementar são
                dedutíveis da base de cálculo do imposto de renda até o limite
                de 12% dos seus rendimentos tributáveis anuais?
              </p>
              <p>
                Visando incentivar a formação de uma reserva para futuro, o
                incentivo fiscal é dado pelo governo para quem faz contribuições
                para planos de previdência complementar.
              </p>
            </TextBox>
            <Line />
            <InfoContent>
              <div className="infoSimple">
                <p>Como você gostaria de fazer sua contribuição adicional?</p>
              </div>
              <div className="infoSimple">
                <input
                  type="checkbox"
                  id="pctAdic"
                  name="pctAdic"
                  checked={tipCtbAdic === 'P'}
                  onChange={e => {
                    handleTipoCtbAdic(e.target.checked ? 'P' : '')
                  }}
                />
                <label htmlFor="pctAdic">
                  {tipCtbAdic === 'P' ? (
                    <>
                      Percentual sobre o salário:{' '}
                      <strong>{formatValue(vlrCtbSup)}</strong>
                    </>
                  ) : (
                    <>Percentual sobre o salário</>
                  )}
                </label>
              </div>
              <Collapse in={tipCtbAdic === 'P'}>
                <UPBoxSlider style={{ paddingBottom: '0px' }}>
                  <InputSlider
                    name="rangeContribSuplementar"
                    functionChange={e => handleChangePctSup(e)}
                    start={0}
                    end={15}
                    initialValue={pctCtbSup}
                    step={0.1}
                    key={0}
                    marks={marksSup}
                    valueLabelDisplay="off"
                    sufix="%"
                  />
                </UPBoxSlider>
              </Collapse>
              <div className="infoSimple">
                <input
                  type="checkbox"
                  id="vlrFixoAdic"
                  name="vlrFixoAdic"
                  checked={tipCtbAdic === 'F'}
                  onChange={e => {
                    handleTipoCtbAdic(e.target.checked ? 'F' : '')
                  }}
                />
                <label htmlFor="vlrFixoAdic">Valor fixo</label>
              </div>
              <Collapse in={tipCtbAdic === 'F'} style={{ marginTop: '12px' }}>
                <Input
                  icon={FiDollarSign}
                  name="contribuicaoSuplementar"
                  // value={ValorMascarar(vlrCtbSup.toFixed(2).toString())}
                  mask="currency"
                  type="text"
                  placeholder="Valor fixo para contribuição adicional"
                  onChange={e => mudarVlrFixoCtbAdic(e.target.value)}
                />
              </Collapse>
              <Line />
              <InfoContent>
                <div className="infoTotal">
                  <h4>Valor total da contribuição adicional:</h4>
                  <strong>{formatValue(auxVlrCtbAdic)}</strong>
                </div>
              </InfoContent>
            </InfoContent>
          </Content>

          <Content>
            <InfoContent style={{ margin: '0px' }}>
              <div className="infoTotal">
                <div>
                  <h3>Valor total que será descontado em folha:</h3>
                  <small>Contribuição básica + adicional</small>
                </div>
                <strong>{formatValue(vlrCtbBasica + auxVlrCtbAdic)}</strong>
              </div>
            </InfoContent>
          </Content>
        </Form>

        <Button color="orange" onClick={handleClick} width="large">
          Simular valores
        </Button>
        <BtnVoltar type="button" onClick={() => history.push('/start')}>
          &lt; Voltar
        </BtnVoltar>
      </Container>
    </>
  )
}

export default Contribution
